import UniProtEntryDataLoader from './UniProtEntryDataLoader';

const loadComponent = function() {
  customElements.define('uniprot-entry-data-loader', UniProtEntryDataLoader);
};

// Conditional loading of polyfill
if (window.customElements) {
    loadComponent();
} else {
    document.addEventListener('WebComponentsReady', function() {
        loadComponent();
    });
}

export default UniProtEntryDataLoader;
